module.exports = __webpack_public_path__ + "static/media/cigna-ce-text.f6069181.png";